import React, { lazy } from 'react';
import { Crosshair, CheckCircle2, ArrowRight } from 'lucide-react';
export function Adas() {
  const valuePoints = ['Windshield replacement and ADAS recalibration handled in one place', 'Trained technicians and calibration equipment', 'Helps reduce extra appointments and downtime', 'Supports proper safety-system function after replacement'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-19">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-20">
            {/* Image */}
            <div className="relative bg-slate-100 min-h-[280px] lg:min-h-full" data-id="element-21">
              <img src="https://cdn.magicpatterns.com/uploads/whjkjtafEvt5KVsMAfAGAt/%E2%80%9CWindshield.png" alt="Auto glass technician using ADAS calibration equipment in front of an SUV after windshield replacement" className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-22" />
              <div className="hidden sm:flex absolute bottom-4 left-4 bg-white border border-slate-200 shadow-md rounded-xl px-4 py-3 items-center gap-3" data-id="element-23">
                <div className="bg-brand-redLight p-2 rounded-lg" data-id="element-24">
                  <Crosshair className="w-5 h-5 text-brand-red" data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-27">
                    In-House
                  </div>
                  <div className="text-sm font-bold text-slate-900" data-id="element-28">
                    ADAS Calibration
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-29">
              <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5 w-fit border border-brand-redBorder" data-id="element-30">
                <Crosshair className="w-3.5 h-3.5" data-id="element-31" />
                <span data-id="element-32">Safety Systems</span>
              </div>

              <h2 className="text-3xl lg:text-4xl font-black text-slate-900 mb-5 leading-tight tracking-tight" data-id="element-33">
                Windshield Replacement May Require{' '}
                <span className="text-brand-red" data-id="element-34">ADAS Calibration</span>
              </h2>

              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-35">
                Many newer vehicles have cameras and sensors mounted near the
                windshield for driver-assistance features. After windshield
                replacement, those systems may need recalibration so features
                such as lane departure warning, adaptive cruise control, forward
                collision warning and automatic emergency braking work
                correctly.
              </p>

              <ul className="space-y-3 mb-7" data-id="element-36">
                {valuePoints.map((point, i) => <li key={i} className="flex items-start gap-3" data-id="element-37">
                    <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-38">
                      <CheckCircle2 className="w-3 h-3 text-brand-red" strokeWidth={3} data-id="element-39" />
                    </span>
                    <span className="text-slate-700" data-id="element-40">{point}</span>
                  </li>)}
              </ul>

              <a href="/ADAS-Calibration-On-Site" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-6 py-3.5 rounded-lg font-bold transition-colors w-fit shadow-sm" data-id="element-41">
                Learn About ADAS Calibration
                <ArrowRight className="w-4 h-4" data-id="element-42" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}